module.exports = __webpack_public_path__ + "img/rec-08.3cfaad4b.png";